// features/profile/edit/fieldStyles.ts — the Edit Profile page's input styles (1.27.70),
// kept apart from fields.tsx's components so both stay fast-refresh friendly. Same
// metrics and fills as ui/TextField.
import styled, { css } from 'styled-components';

export const controlStyles = css<{ $invalid?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme, $invalid }) =>
    $invalid
      ? `color-mix(in srgb, ${theme.color.danger} 12%, ${theme.color.surface})`
      : theme.color.surface};
  color: ${({ theme }) => theme.color.textPrimary};
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: ${({ theme }) => theme.lineHeight.sm};
  outline: none;
  &::placeholder {
    color: ${({ theme }) => theme.color.textFaint};
  }
  &:focus-visible {
    border-color: ${({ theme }) => theme.color.accentCyan};
    box-shadow: ${({ theme }) => theme.elevation.glow};
  }
  &:disabled,
  &[readonly] {
    color: ${({ theme }) => theme.color.textMuted};
    background: ${({ theme }) => theme.color.glassBg};
    cursor: default;
  }
`;

export const TextInput = styled.input<{ $invalid?: boolean }>`
  ${controlStyles}
`;

export const TextArea = styled.textarea<{ $invalid?: boolean }>`
  ${controlStyles}
  resize: vertical;
  min-height: 84px;
`;

export const Select = styled.select<{ $invalid?: boolean }>`
  ${controlStyles}
  cursor: pointer;
`;
